import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PageHero from "@/components/PageHero";
import { api } from "@/lib/api";
import Seo from "@/components/Seo";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { api.get("/faqs").then((r) => setFaqs(r.data)).catch(() => {}); }, []);
  const faqJsonLd = faqs.length ? {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map((f) => ({
      "@type": "Question",
      "name": f.question,
      "acceptedAnswer": { "@type": "Answer", "text": f.answer },
    })),
  } : undefined;
  return (
    <div data-testid="faq-page">
      <Seo
        title="Catering FAQ | Deposits, Service Area & Policies — K.O Chef & Catering"
        description="Frequently asked questions about K.O Chef & Catering: deposits, cancellation policy, minimum guests, service area, dietary restrictions, allergies, setup, cleanup and staffing."
        path="/faq"
        jsonLd={faqJsonLd}
      />
      <PageHero overline="FAQ" title="Questions, Answered"
        subtitle="Everything you need to know before booking your event."
        image="https://images.unsplash.com/photo-1676471926534-d5c9771909fa?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000" />
      <section className="py-20 md:py-28">
        <div className="container-lux max-w-3xl">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem key={f.id} value={f.id} className="border-b border-white/10" data-testid={`faq-${i}`}>
                <AccordionTrigger className="text-left text-lg font-light text-white hover:text-gold hover:no-underline py-6">
                  {f.question}
                </AccordionTrigger>
                <AccordionContent className="text-white/60 leading-relaxed pb-6 text-base">
                  {f.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
          <div className="text-center mt-16">
            <p className="text-white/50 mb-6">Still have questions?</p>
            <Link to="/contact" className="btn-gold" data-testid="faq-contact-btn">Contact Us</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
